import request from "@/utils/request";

export function getPage(condition, pagination) {
  return request({
    url: "/crm/sales/page",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}
export function saveOrUpdate(data) {
    return request({
      url: "/crm/sales/saveOrUpdate",
      method: "post",
      data,
    });
  }
  
  export function get(id) {
    return request({
      url: "/crm/sales/get",
      method: "get",
      params: { id },
    });
  }
export function deleteById(id) {
    return request({
      url: "/crm/sales/deleteById",
      method: "post",
      data: { id: id },
    });
  }
  // 根据销售组织返回客户
  export function getByCustomerApply(data) {
    return request({
      url: "/customer/customerApply/getByCustomerApply",
      method: "post",
      data
    });
  }
  // 根据销售组织查询中间公司
  export function getByMiddleCompany(data) {
    return request({
      url: "/base/company/getByCompanyOfTransaction",
      method: "post",
      data
    });
  }
  // 
  export function submit(id) {
    return request({
      url: "/crm/sales/submit",
      method: "post",
      data: { id: id },
    });
  }
  export function downloadMountingsLineTemplate() {
    return request({
      url: '/crm/sales/line/downloadTemplate',
      method: 'post',
      responseType: 'blob'
    })
  }
  export function downloadPutIntoZP03LineTemplate() {
    return request({
      url: '/crm/sales/line/downloadTemplates',
      method: 'post',
      responseType: 'blob'
    })
  }
  // 查询来源订单
  export function getSourceApi(data) {
    return request({
      url: "/crm/sales/searchSourceOrders",
      method: "post",
      data
    });
  }
  // 查询来源订单配件明细
  export function searchSourceOrders(data) {
    return request({
      url: "/crm/sales/searchSourceOrdersParts",
      method: "post",
      data
    });
  }
    // 查询来源订单废料明细
    export function searchSourceOrdersFlotsam(data) {
      return request({
        url: "/crm/sales/searchSourceOrdersFlotsam",
        method: "post",
        data
      });
    }
export function getFollowerApi(data) {
  return request({
    url: "/system/admin/getByRoleCode",
    method: "post",
    data
  });
}

// 销售订单废料查询图片列表
export function getCommonList(data) {
  return request({
    url: "crm/common/attachment/busiList",
    method: "post",
    data
  });
}

// 销售订单废料查询图片列表
export function saveCommon(data) {
  return request({
    url: "crm/common/attachment/saveOrUpdate",
    method: "post",
    data
  });
}

// 删除销售配件
export function delCommon(id) {
  return request({
    url: 'crm/common/attachment/delete/' + id,
    method: 'delete'
  })
}